import {Theme} from 'exsportia-components'
import {Button as RawButton} from 'exsportia-components/dist/components/atoms'
import {ComponentProps} from 'react'

import {ThemeType} from '../../../theme/types'

export type ButtonStyle = Partial<ComponentProps<typeof RawButton>>

const primary: ButtonStyle = {styleType: 'primary', settings: {width: '100%', bg: 'primary'}}

const flat: ButtonStyle = {
  styleType: 'link',
  settings: {
    width: '100%',
    color: 'primary',
    text: {m: '0 8px 0 8px'},
    icon: {color: (Theme as ThemeType).colors.sport},
    hover: {bg: 'unset'},
    active: {bg: 'unset'},
  },
}

const flat_short: ButtonStyle = {
  ...flat,
  settings: {...flat.settings, p: 0, width: 'max-content'},
}

const secondary: ButtonStyle = {
  styleType: 'secondary',
  settings: {width: '100%'},
  additionalStyles: ['fullSize'],
}

const cancel: ButtonStyle = {
  ...secondary,
  settings: {
    ...secondary.settings,
    color: 'error',
  },
}

const primary_green: ButtonStyle = {
  ...primary,
  settings: {
    ...primary.settings,
    width: 'unset',
    bg: 'success',
  },
}

const icon: ButtonStyle = {
  ...flat,
  settings: {
    ...flat.settings,
    p: 0,
    width: 'max-content',
    color: 'text-secondary',
    icon: {
      color: 'rgba(44, 45, 46, 1)',
    },
  },
}

export const buttonStylesMap = {
  flat,
  icon,
  cancel,
  primary,
  secondary,
  flat_short,
  primary_green,
}
